import { render } from "./CustomFileThumbnail.vue?vue&type=template&id=09329a3e"
import script from "./CustomFileThumbnail.vue?vue&type=script&lang=ts"
export * from "./CustomFileThumbnail.vue?vue&type=script&lang=ts"
script.render = render

export default script